
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destination/[id]",
      function () {
        return require("private-next-pages/destination/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destination/[id]"])
      });
    }
  